/*
 * Scroll-Anzeige fuer seitlich wischbare Bereiche auf dem Handy (seitenweit).
 * Findet Elemente mit overflow-x auto/scroll, die breiter als ihr Rahmen sind,
 * und setzt darunter einen duennen Balken (.s4t-hbar), der Groesse und Position
 * des sichtbaren Ausschnitts zeigt. Ohne Ueberlauf blendet er sich aus.
 * Ausgenommen: Brotkruemel, Handymenue und Suchfenster (eigene Balken),
 * Slider mit eigenen Punkten. CSS in assets/custom-critical.css.
 */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 767px)');
  var SKIP = '.breadcrumbs, #mobile-menu, #Search-Drawer, #Cart-Drawer, .side-panel, .flickity-enabled, .swiper, .pswp, [data-s4t-hbar-off]';

  function attach(el) {
    el.setAttribute('data-s4t-hbar', '');
    var bar = document.createElement('div');
    bar.className = 's4t-hbar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    bar.appendChild(thumb);
    var parent = el.parentElement;
    var ps = parent ? getComputedStyle(parent) : null;
    if (ps && ps.display.indexOf('flex') > -1 && ps.flexDirection.indexOf('row') === 0 && ps.flexWrap === 'nowrap') {
      // Flex-Zeile ohne Umbruch: Balken unter den Container statt als Spalte daneben
      parent.after(bar);
    } else {
      el.after(bar);
      if (ps && ps.display.indexOf('grid') > -1) bar.style.gridColumn = '1 / -1';
      if (ps && ps.display.indexOf('flex') > -1) bar.style.flexBasis = '100%';
    }
    function update() {
      var sw = el.scrollWidth, cw = el.clientWidth;
      if (!mq.matches || !cw || sw <= cw + 4 || el.offsetParent === null) { bar.hidden = true; return; }
      bar.hidden = false;
      // Randlose Bereiche: Balken mit Seitenabstand wie der Inhalt
      if (!bar._inset && bar.getBoundingClientRect().width >= window.innerWidth - 1) { bar.style.marginLeft = bar.style.marginRight = '15px'; }
      bar._inset = true;
      var size = cw / sw;
      var max = sw - cw;
      var pos = Math.min(1, Math.max(0, Math.abs(el.scrollLeft) / max));
      thumb.style.width = (size * 100) + '%';
      thumb.style.left = (pos * (1 - size) * 100) + '%';
    }
    el.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(el);
    window.addEventListener('resize', update);
    update();
  }

  function scan() {
    if (!mq.matches) return;
    var all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.hasAttribute('data-s4t-hbar')) continue;
      if (el.scrollWidth <= el.clientWidth + 4 || el.clientWidth < 120 || el.clientHeight < 30) continue;
      var ox = getComputedStyle(el).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') continue;
      if (el.closest(SKIP)) continue;
      var next = el.nextElementSibling;
      if (next && /s4t-promo-bar|mm-scrollbar|flickity-page-dots|swiper-pagination/.test(next.className)) continue;
      attach(el);
    }
  }

  var timer = null;
  function later(ms) { clearTimeout(timer); timer = setTimeout(scan, ms || 400); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', function () { later(300); });
  if (mq.addEventListener) mq.addEventListener('change', function () { later(100); });
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && !(added[j].classList && added[j].classList.contains('s4t-hbar'))) { later(500); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
